import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialGlobalState from './initialState';
import { IReportingState } from './types';

const reportingSlice = createSlice({
  name: 'reporting',
  initialState: initialGlobalState(),
  reducers: {
    set_selectedDate(state: IReportingState, action: PayloadAction<string>) {
      state.date = action.payload;
    },
    set_selectedICTService(
      state: IReportingState,
      action: PayloadAction<number>,
    ) {
      state.ictService_id = action.payload;
    },
    set_selectedFunction(
      state: IReportingState,
      action: PayloadAction<number>,
    ) {
      state.function_id = action.payload;
    },
    set_isDisplayed(state: IReportingState, action: PayloadAction<boolean>) {
      state.is_displayed = action.payload;
    },
    set_isAdditionalDisplayed(
      state: IReportingState,
      action: PayloadAction<boolean>,
    ) {
      state.is_additional_displayed = action.payload;
    },
    set_headers(state: IReportingState, action: PayloadAction<string[]>) {
      state.headers = action.payload;
    },
    set_reports(state: IReportingState, action: PayloadAction<unknown>) {
      state.dataReport99 = action.payload;
    },
    set_selectedICTSystemByFunction(
      state: IReportingState,
      action: PayloadAction<number>,
    ) {
      state.ict_system_by_function = action.payload;
    },
    set_selectedICTSystembyICTService(
      state: IReportingState,
      action: PayloadAction<number>,
    ) {
      state.ict_system_by_ict_service = action.payload;
    },
    set_financialEntityLeiId(
      state: IReportingState,
      action: PayloadAction<number>,
    ) {
      state.financial_entity_lei_id = action.payload;
    },
  },
});

export const {
  set_selectedDate,
  set_isDisplayed,
  set_isAdditionalDisplayed,
  set_headers,
  set_reports,
  set_selectedICTService,
  set_selectedFunction,
  set_selectedICTSystemByFunction,
  set_selectedICTSystembyICTService,
  set_financialEntityLeiId,
} = reportingSlice.actions;
export default reportingSlice;
